<script setup lang="ts">
import MapMarkerIcon from "@/components/map/MapMarkerIcon.vue";
import MapMarkerHouseHiddenIcon from "./MapMarkerHouseHiddenIcon.svg";

const { hidden = false, color = "var(--fill-color-grey)" } = defineProps<{
  hidden?: boolean;
  color?: string;
}>();
</script>

<template>
  <MapMarkerIcon v-if="!hidden" class="house-pin" />
  <MapMarkerHouseHiddenIcon v-else class="map-marker-icon house-pin hidden" />
</template>

<style scoped>
.house-pin {
  color: v-bind(color);

  &.hidden {
    color: var(--fill-color-grey-light);
  }
}
</style>
